import React, {useContext} from "react"
import {TextField, Box} from "@mui/material"
import Grid from '@mui/material/Grid';
import makeStyles from "@material-ui/core/styles/makeStyles";
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {NumberFormatCustom} from "../../../services/validation";
import {updateCategoryStatus} from "../../../api/category";
import {LoadingContext} from "../../../hoc/loading";
import {MessageContext} from "../../../hoc/messageNotification";
import {SUPER_ADMIN} from "../../../constants";
import {RoleContext} from "../../../hoc/role";

const useStyles = makeStyles({
    input: {
        margin: '0px',
    },
    main: {
        margin: 0
    },
    category: {
        width: '100%'
    },
    subCategory: {
        width: '90%'
    },
});

export const Item = ({category, remove, ind, onChangeData}) => {
    const classes = useStyles();
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const {role} = useContext(RoleContext);

    const updateCategory = async (category, active) => {
        try {
            setLoading(true);
            setErrorMessage(null);
            const {id} = category

            await updateCategoryStatus(id, active)

        } catch (e) {
            category['active'] = !category['active']
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const onChange = async (event, ind) => {
        try{
            const name = event.target.name
            let value = event.target.value

            if(event.target.type === 'checkbox'){
                value = event.target.checked
            }

            category[name] = value

            if(event.target.type === 'checkbox'){
                await updateCategory(category, value)
            }

            onChangeData(category, event.target.type === 'checkbox' ? true : false)
        }catch (e) {

        }
    }

    return (
        <Grid container className={classes.main} spacing={2}>
            <Grid item xs={12} md={4}>
                <Box display={"flex"}
                     justifyContent={"flex-end"}>
                    <OutlinedInput
                        className={!category.subCategories ? classes.subCategory : classes.category}
                        fullWidth
                        startAdornment={
                            !category.subCategories && role === SUPER_ADMIN ?  <IconButton onClick={() => remove(ind)} aria-label="delete">
                            <RemoveCircleOutlineIcon/>
                            </IconButton> : ''
                        }
                        onChange={(e) => onChange(e, ind)}
                        name='name'
                        value={category.name}
                        disabled={category.active}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} md={4}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <TextField
                        disabled={category.active}
                        className={classes.input}
                        inputProps={{required: true}}
                        name='free' onChange={(e) => onChange(e, ind)}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                        max={100}
                        value={category.free} label="Free" variant="outlined"/>
                    <TextField className={classes.input}
                               name='purchased'
                               inputProps={{required: true}}
                               disabled={category.active}
                               onChange={(e) => onChange(e, ind)}
                               InputProps={{
                                   inputComponent: NumberFormatCustom,
                               }}
                               max={100}
                               value={category.purchased} label="Purchased" variant="outlined"/>
                </Box>
              </Grid>
            <Grid item md={4}/>
        </Grid>
    )
}